<template lang="pug">
  div.special
    //- HeaderTheme(v-if="headPic.src", :imgUrl="headPic.src")
    div.main-content(v-if="list.length==0")
      div.product-list-wrapper
        Empty
    div.main-content(v-for="itemss in list")
      div.special-name {{itemss.navigation.name}}
        span(style="font-size: .8125rem;color: #0080a3;margin-left:.8125rem;",@click="shopAll(itemss)") 查看全部
      div.ai(style="border-top:1px solid #e7e7ef;margin:0 0.75rem")
      //- div.filter-sort-wrapper
        section.filter-sort
          FilterBy.filter(:toggle="toggleFilter")
          //- Sort.sort
        section.filter-wrapper
          div.filter-tags
            button.close-filter(@click="toggleFliterWider", v-show="list.length")
              i.icon.iconfont(:class="`${filterPanelWiderShow ? 'icon-close': 'icon-menu'}`")
              span 筛选
            div.tags
              //- Tags
              AddedOption(:clearItem="clearItem"
                          :clearAllItems="clearAllItems",
                          :selectedFilters="selectedFilters")
          //- div.sort
            Sort
      div.content
        FilterPanel.filter-panel(:class="`${filterPanelShow? 'show': 'hide'}`"
                                 :toggle="toggleFilter"
                                 :filters="filters"
                                 :addFilterCondition="addFilterCondition"
                                 :clearItem="clearItem"
                                 :clearAllItems="clearAllItems")
          template(slot="addedOption")
            AddedOption(:clearItem="clearItem",
                        :clearAllItems="clearAllItems",
                        :selectedFilters="selectedFilters")
        FilterPanelWider.filter-pannel-wider(:class="`${filterPanelWiderShow? 'show': 'hide'}`"
                                             :filters="filters"
                                             :addFilterCondition="addFilterCondition"
                                             :clearItem="clearItem"
                                             :clearAllItems="clearAllItems"
                                             )
        div.product-list-wrapper
          Empty(v-if="loaded && !itemss.list", :category="itemss.navigation")
          div.proudct-list
            Product.product(v-for="(item, index) in itemss.list", :key="index", :item="item")
          Loading(v-show="loading")
</template>

<script>
import HeaderTheme from '@/components/HeaderTheme.vue'
import FilterBy from '@/components/Special/Filter.vue'
import FilterPanel from '@/components/Special/FilterPanel.vue'
import Sort from '@/components/Special/Sort.vue'
import Product from '@/components/Detail/Product.vue'
import Tags from '@/components/Special/Tags.vue'
import FilterPanelWider from '@/components/Special/FilterPannelWider.vue'
import AddedOption from '@/components/Special/AddedOption.vue'
import Loading from '@/components/Loading.vue'
import Empty from '@/components/Special/Empty'
import { getMainCategoryPage, getHomePage } from '@/services/index'
export default {
  name: 'Special',
  data () {
    return {
      banner: null,
      headPic: null,
      filters: [],
      filterPanelShow: false,
      filterPanelWiderShow: false,
      loading: false,
      loaded: false,
      more: true,
      specialList: [],
      list: [],
      menu: [],
      menuName: [],
      distanceToBottom: 20,
      specialName: '',
      specialId: '',
      parents: [],
      selectedSort: null,
      selectedFilters: [],
      params: {
        page: 1,
        navigation_id: ''
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        // this.specialName = newValue.params.name
        this.specialId = newValue.query.id
        this.params.navigation_id = newValue.query.id
        this.parents = newValue.query.parent
        this.params.page = 1
        this.more = true
        this.loading = false
        this.list = []
        this.parents = []
        this.loadmore()
      }
    }
  },
  computed: {
    paramsOption () {
      let params = {}
      this.selectedFilters.forEach(d => {
        params[d.attribute] = d.key
      })
      return params
    }
  },
  created () {
    this.loadmore()
    getHomePage().then(res => {
      this.banner = res.data.banner
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.scroller = () => {
        let canScrollHeight =
          document.body.clientHeight - document.documentElement.clientHeight
        if (window.scrollY > canScrollHeight - this.distanceToBottom) {
          if (!this.loading) {
            this.loadmore()
          }
        }
      }
      document.addEventListener('scroll', this.scroller)
    })
  },
  methods: {
    shopAll (val) {
      let link = `/kid/${val.navigation.name}?parent=special&id=${val.navigation.id}`
      // let link = `/${val.navigation.route}/${val.navigation.name}?parent=${val.navigation.parent}&id=${val.navigation.id}`
      this.$router.push({
        path: link
      }, () => {
        // this.$store.dispatch('toggleShowNavigation')
      })
    },
    // inits () {
    //   if (this.specialId !== '') {
    //     getNavigation().then(res => {
    //       for (var i in res.data) {
    //         for (var j in res.data[i].items) {
    //           if (parseInt(res.data[i].items[j].id) === parseInt(this.specialId)) {
    //             this.menuName = res.data[i].items[j].items
    //             for (var f in this.menuName) {
    //               for (var k in this.specialList) {
    //                 if (this.menuName[f].id === this.specialList[k][0].navigation_id) {
    //                   this.menuName[f].items = this.specialList[k]
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     })
    //   }
    // },
    init () {
      this.params.page = 1
      this.more = true
      this.list = []
      this.loading = false
      this.loaded = false
    },
    loadmore () {
      if (!this.loading && this.more) {
        this.loading = true
        let params = {
          ...this.params,
          ...this.paramsOption
        }
        getMainCategoryPage(params).then(res => {
          if (res.data.products.length < 12) {
            this.more = false
          }
          // this.inits()
          this.filters = res.data.filter
          // var nary = res.data.products.sort()
          // for (var i = 0; i < res.data.products.length; i++) {
          //   if (i + 1 < res.data.products.length) {
          //     if (nary[i].id === nary[i + 1].id) {
          //       product.push([nary[i], nary[i + 1]])
          //     }
          //   }
          // }
          // for (var w in product) {
          //   for (var k in res.data.products) {
          //     if (product[w][0].id === res.data.products[k].id) {
          //       delete res.data.products[k]
          //       res.data.products[k] = product[w]
          //     }
          //   }
          // }
          // for (var s = 0; s < res.data.products.length; s++) {
          //   if (!nary[s][0]) {
          //     nary[s] = [nary[s]]
          //   }
          //   if (nary[i] === nary[s + 1]) {
          //     nary.splice(s + 1, 1)
          //   }
          // }
          // res.data.products = nary
          // this.specialList = nary
          // this.list = [[...this.list, ...res.data.products]]
          this.list = res.data.products
          this.headPic = res.data.banner
          this.loading = false
          this.params.page = this.params.page + 1
          this.loaded = true
        })
      }
    },
    clearAllItems () {
      this.selectedFilters = []
      this.init()
      this.loadmore()
    },
    clearItem (item) {
      let items = this.selectedFilters.filter(filter => filter.value !== item.value)
      this.selectedFilters = items
      this.init()
      this.loadmore()
    },
    addFilterCondition (item, attribute) {
      let items = this.selectedFilters
        .filter(filter => (filter.attribute !== attribute))
      items = [...items, {
        ...item,
        attribute: attribute
      }]
      this.selectedFilters = items
      this.init()
      this.loadmore()
    },
    toggleFilter () {
      this.filterPanelShow = !this.filterPanelShow
    },
    toggleFliterWider () {
      this.filterPanelWiderShow = !this.filterPanelWiderShow
    }
  },
  components: {
    FilterBy,
    FilterPanel,
    FilterPanelWider,
    Sort,
    Product,
    Tags,
    AddedOption,
    Loading,
    Empty,
    HeaderTheme
  }
}
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 5rem;
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.main-content .content {
  position: relative;
  overflow: hidden;
}

.proudct-list {
  align-self: flex-start;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  // align-items: flex-start;
  padding: 0 10px;
}

.filter-sort {
  padding: 15px 10px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .filter,
  .sort {
    flex: 1;
    // width: calc((100% - 10px) / 2);
  }
}

.product {
  width: calc(75% / 2);
  margin: 1rem 0;
  overflow: hidden;
}

.special-name {
  text-align: left;
  font-weight: bold;
  color: #1a1a1a;
  // font-size: 2rem;
  text-transform: uppercase;
  padding: 0 10px;
  margin-top: 1.875rem;
  margin-bottom: 1rem;
  span {
    cursor: pointer;
  }
}

.tags {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  align-items: center;
}
.filter-panel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100000000000;
  height: 100vh;
  overflow: hidden;
  background: #fff;
}

.filter-panel.show {
  display: block;
}
.filter-panel.hide {
  display: none;
}

.main-content {
  position: relative;
}

.product-list-wrapper {
  flex: 1;
}
.filter-wrapper {
  display: none;
  flex-flow: row nowrap;
  // justify-content: space-between;
  align-items: center;
  margin: 2.1875rem 0 1.875rem;
  padding: 0 10px;
  label {
    margin: 0 0.9375rem 0 0;
  }

  select {
    padding: 0.125rem 0 0.125rem 0.9375rem;
    border: none;
  }
}

.filter-tags {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}

.close-filter {
  background: transparent;
  border: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  .icon {
    margin-right: 0.5em;
  }
}

.filter-panel-wider {
  position: relative;
  display: none;
  flex-shrink: 0;
}

.filter-panel-wider.show {
  transition: all linear 0.3s;
}
.filter-panel-wider.hide {
  transition: all 0.3s cubic-bezier(0.68, 0, 0.51, 1);
}

@media only screen and (min-width: 767px) {
  .filter-panel {
    display: none;
  }
  .special-name { //sss
    font-size: 2rem;
  }
  .filter-panel.show {
    display: none;
  }
  .filter-panel-wider {
    display: block;
    width: 12.5rem;
  }

  .filter-panel-wider.hide {
    margin-left: -12.5rem;
    transition: all 0.3s cubic-bezier(0.68, 0, 0.51, 1);
  }

  .content {
    display: flex;
    flex-flow: row nowrap;
  }
  .filter-sort {
    display: none;
  }
  .filter-wrapper {
    display: flex;
  }
}
@media only screen and (min-width: 480px) and (max-width: 767px) {
  .product {
    width: calc(75% / 3);
  }
}

@media only screen and (max-width: 959px) {
  .product {
    width: calc(75% / 2);
  }
}

@media only screen and (min-width: 960px) {
  .filter-panel-wider {
    display: block;
    width: 14.6875rem;
  }

  .filter-panel-wider.hide {
    margin-left: -14.6875rem;
    transition: all 0.3s cubic-bezier(0.68, 0, 0.51, 1);
  }
}
@media only screen and (max-width: 1399px) {
  .product {
    width: calc(75% / 3);
  }
}

@media only screen and (min-width: 1399px) {
  .product {
    width: calc(75% / 4);
  }

  .main-content {
    margin: 0 1.2rem 5rem 1.2rem;
  }
}

@media  only screen and (min-width: 1600px) {
      .main-content {
    max-width: 1600px;
    margin: 0 auto 5rem auto;
  }
}
</style>
